/**
 * DI-01 — the text of every slide, in order, via the OOXML extractor (covers tables, groups, SmartArt).
 * Returns null when the deck can't be read, which is distinct from an empty deck.
 */

import { logOfficeError } from "../../../../../telemetry";
import { getActivePresentationBytesShared } from "../../../../deckorate/features/CompareSlides/services/pptxBytesShared";
import { extractAllSlidesText } from "../../../../deckorate/features/CompareSlides/services/pptxTextExtractor";
import { hasPpt } from "../../../utils/officeHost";
import type { SlideText } from "../types";

export interface DeckReaderDeps {
  readBytes?: (forceRefresh?: boolean) => Promise<ArrayBuffer>;
  extract?: typeof extractAllSlidesText;
}

export async function readDeckSlides(deps: DeckReaderDeps = {}): Promise<SlideText[] | null> {
  const { readBytes = getActivePresentationBytesShared, extract = extractAllSlidesText } = deps;
  if (!hasPpt()) return null;
  try {
    // Bypass the shared cache: the user may have edited the deck since the last read.
    const slides = await extract(await readBytes(true));
    return slides.map((s) => ({ slideNumber: s.slideNumber, text: s.fullText }));
  } catch (e) {
    logOfficeError(e, "ppt-summarise-deck-read");
    return null;
  }
}
